import ApiClient from './ApiClient';

export const createAutoQuotationRecord = ({ body, token }) => {
  return ApiClient.post(
    '/api/auto_quotation_records',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};

export const updateAutoQuotationRecord = ({ recordId, body, token }) => {
  return ApiClient.put(
    `/api/auto_quotation_records/${recordId}`,
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};

export const fetchAutoQuotationRecords = ({ token }) => {
  return ApiClient.get(
    '/api/auto_quotation_records',
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};

export const fetchAutoQuotationRecord = ({ recordId, token }) => {
  return ApiClient.get(
    `/api/auto_quotation_records/${recordId}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};

export const downloadQuotationPdf = (body, token) => {
  return ApiClient.post(
    '/api/download_quotation_pdf',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      withCredentials: false,
    }
  );
};

// The Plan Comparison dialog's PDF: its TOB with the premium comparison at the end, as one table
export const downloadQuickQuotationPdf = (body, token) => {
  return ApiClient.post(
    '/api/download_quick_quotation_pdf',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      withCredentials: false,
    }
  );
};

export const downloadQuotationExcel = (body, token) => {
  return ApiClient.post(
    '/api/download_quotation_excel',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      withCredentials: false,
    }
  );
};

export const deleteAutoQuotationRecord =({ recordId, token }) => {
  return ApiClient.delete(
    `/api/auto_quotation_records/${recordId}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};
